"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedNetworks = void 0;
const avalanche_1 = require("./avalanche");
const bsc_1 = require("./bsc");
const bsctest_1 = require("./bsctest");
const celo_1 = require("./celo");
const fantom_1 = require("./fantom");
const goerli_1 = require("./goerli");
const mainnet_1 = require("./mainnet");
const matic_1 = require("./matic");
const moonbeam_1 = require("./moonbeam");
const optimism_1 = require("./optimism");
const rinkeby_1 = require("./rinkeby");
const xdai_1 = require("./xdai");
exports.supportedNetworks = {
    celo: celo_1.supportedCeloERC20,
    // FIXME: Rinkeby is deprecated
    rinkeby: rinkeby_1.supportedRinkebyERC20,
    goerli: goerli_1.supportedGoerliERC20,
    mainnet: mainnet_1.supportedMainnetERC20,
    matic: matic_1.supportedMaticERC20,
    fantom: fantom_1.supportedFantomERC20,
    bsctest: bsctest_1.supportedBSCTestERC20,
    bsc: bsc_1.supportedBSCERC20,
    xdai: xdai_1.supportedXDAIERC20,
    avalanche: avalanche_1.supportedAvalancheERC20,
    optimism: optimism_1.supportedOptimismERC20,
    moonbeam: moonbeam_1.supportedMoonbeamERC20,
};
